<template>
    <div>
      <div class="err-n">401</div>
      <div class="err-msg">
        <h2>{{ $t('Внимание') }}!</h2>
        <p>{{ $t('У Вас нет доступа к данной странице. Пожалуйста авторизуйтесь. С уважением, администрация портала') }}.</p>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Error401"
    }
</script>

<style scoped>

</style>
